import script from "./ControlPalette.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlPalette.vue?vue&type=script&setup=true&lang=js"

import "./ControlPalette.vue?vue&type=style&index=0&id=5a1e209a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1e209a"]])

export default __exports__